import React, {Fragment, useState} from 'react';
import {Listbox, Transition} from '@headlessui/react';
import {
  dropdownFillWhite,
  dropdownGrey,
  dropdownNoFill,
  logoutRed,
} from '../assets/images/images';
import PuffLoader from 'react-spinners/PuffLoader';
import {css} from '@emotion/react';
import {useMediaQuery} from '../hooks';
import {useDispatch} from 'react-redux';
import * as Actions from '../store/actions';
import ConfirmLogoutModal from './ConfirmLogoutModal';

export default function SingleDropdown({
  dropdownData,
  selected,
  setSelected,
  spanText,
  selectedId,
  width,
  children,
  loading,
  customTrigger,
}) {
  const dispatch = useDispatch();
  const override = css`
    border-color: #ffffff;
    position: absolute;
    background: transparent;
    padding-right: 50px;
  `;
  const media = useMediaQuery('(min-width: 768px)');
  const [showCompanies, setShowCompanies] = useState(false);
  const [rotateIcon, setRotateIcon] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const toggleCompanies = () => {
    setShowCompanies(!showCompanies);
    setRotateIcon(!rotateIcon);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setLoggingOut(true);
    dispatch(Actions?.logout());
  };

  const hasSingleCompany = dropdownData?.length === 1;
  const isProfiledRisk = localStorage
    ?.getItem('subdomain')
    ?.includes('profiledrisk');

  return (
    <div className="lg:max-w-72 w-full">
      <Listbox value={selected} onChange={setSelected}>
        <div className="relative">
          {customTrigger ? (
            <Listbox.Button as={Fragment}>{customTrigger}</Listbox.Button>
          ) : (
            <Listbox.Button className="test relative w-full flex gap-[37px] items-center justify-between lg:rounded-t-lg rounded-lg md:rounded-none cursor-pointer bg-white md:bg-brandBlue py-3 px-4 md:py-5 md:px-6 text-left focus:outline focus:outline-1 focus:outline-white">
              {loading ? (
                <div className="flex items-center justify-center ml-5 ">
                  <PuffLoader css={override} size={35} color="#ffffff" />
                </div>
              ) : (
                <p className="font-medium text-grey md:text-white truncate">
                  {spanText}
                </p>
              )}
              <img src={media ? dropdownFillWhite : dropdownGrey} alt="" />
            </Listbox.Button>
          )}
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options
              className={`md:absolute md:right-[-16px] border-none outline-none [box-shadow:0px_2px_6px_0px_#0000000F,0px_6px_20px_0px_#0000000F] z-10 md:mt-[12px] flex flex-col rounded-b-xl bg-white ${
                width ?? 'w-[214px]'
              }`}
            >
              {!hasSingleCompany && !isProfiledRisk && (
                <div className="p-2">
                  <>
                    <button
                      className="flex items-center justify-between p-2 w-full"
                      onClick={toggleCompanies}
                    >
                      <p className="hidden font-normal text-sm text-[#1D1F26] md:block">
                        Switch account
                      </p>
                      <img
                        alt="icon"
                        src={dropdownNoFill}
                        className={`transition-transform duration-200 ${
                          rotateIcon ? 'rotate-180' : ''
                        }`}
                      />
                    </button>

                    <Transition
                      show={showCompanies}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-y-0"
                      enterTo="transform opacity-100 scale-y-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-y-100"
                      leaveTo="transform opacity-0 scale-y-0"
                      className="origin-top"
                    >
                      <div>
                        {dropdownData?.map((data, idx) => (
                          <Listbox.Option
                            key={data._id || idx}
                            className={({active}) =>
                              `relative flex items-center justify-between min-h-12 cursor-pointer select-none px-3 py-2 rounded-lg ${
                                active ||
                                (selectedId && selectedId === data._id)
                                  ? 'bg-[#F2F6FD] md:bg-[#F2F6FD] md:opacity-80 outline outline-1 rounded'
                                  : ''
                              }`
                            }
                            value={data}
                          >
                            <span className="font-medium text-[#0B1C56] truncate text-tiny">
                              {data.name}
                            </span>
                          </Listbox.Option>
                        ))}
                      </div>
                    </Transition>
                  </>

                  {children}
                </div>
              )}

              <button
                className="flex items-center gap-3 text-[#B42318] font-normal text-tiny p-4 border border-transparent border-t-[#E6E7EB]"
                onClick={handleLogout}
              >
                <img src={logoutRed} alt="icon" />
                Logout
              </button>
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
      <ConfirmLogoutModal
        open={showLogoutModal}
        onClose={() => !loggingOut && setShowLogoutModal(false)}
        onConfirm={confirmLogout}
        loading={loggingOut}
      />
    </div>
  );
}
